import { useDaumPostcodePopup } from "react-daum-postcode";
import styled from "styled-components";
import theme from "../../style/theme";
import SearchIcon from "../icons/SearchIcon";

interface Props {
  text?: string;
  disabled: boolean;
  disabledText?: string;
  setAddress: (address: string) => void;
}

const CURRENT_URL =
  "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";

export const RoutingServicePostCodeButton: React.FC<Props> = ({
  text,
  disabled,
  disabledText,
  setAddress,
}) => {
  const open = useDaumPostcodePopup(CURRENT_URL);

  const isEmpty = text?.length === 0;

  const handleClickButton = () => {
    if (disabled) return;
    open({ onComplete: handleComplete });
  };

  const handleComplete = (data: any) => {
    let fullAddress = data.address;
    // let extraAddress = "";

    // if (data.addressType === "R") {
    //   if (data.bname !== "") {
    //     extraAddress += data.bname;
    //   }
    //   if (data.buildingName !== "") {
    //     extraAddress +=
    //       extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
    //   }
    //   fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
    // }
    setAddress(fullAddress);
  };

  return (
    <Container
      disabled={disabled}
      isEmpty={isEmpty}
      onClick={handleClickButton}
    >
      <LeftContainer disabled={disabled} isEmpty={isEmpty}>
        {disabled ? disabledText || "최적 배차 종료지" : "주소를 검색하세요"}
      </LeftContainer>
      <LeftLabel disabled={disabled} isEmpty={isEmpty}>
        {disabled
          ? disabledText || "최적 배차 종료지"
          : text || "주소를 검색하세요"}
      </LeftLabel>
      <RightIconContainer>
        <SearchIcon />
      </RightIconContainer>
    </Container>
  );
};

interface ContainerProps {
  disabled: boolean;
  isEmpty: boolean;
}

const Container = styled.div<ContainerProps>`
  position: relative;
  width: 266px;
  height: 41px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  border: 1px solid ${theme.palette.primitives.gray200};
  box-sizing: border-box;
  padding: 0 0 0 12px;
  margin 0;
  // margin: 0 12px;
  background: ${(props) =>
    props.disabled ? theme.palette.primitives.gray50 : "#ffffff"};
  cursor: pointer;
  overflow: hidden;
`;

interface LeftLabelProps {
  disabled: boolean;
  isEmpty: boolean;
}

const LeftContainer = styled.div<LeftLabelProps>`
  width: fit-content;
  height: max-content;
  // height: 12.5px;
  color: ${(props) =>
    props.disabled || props.isEmpty
      ? theme.palette.primitives.gray300
      : theme.palette.primitives.gray900};
  // padding: 7px 0;
  padding: 0;
  margin: 0;
  display: flex;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  box-sizing: border-box;
`;

const LeftLabel = styled.div<LeftLabelProps>`
  position: absolute;
  width: 200px;
  background: ${(props) =>
    props.disabled ? theme.palette.primitives.gray50 : "#ffffff"};
  color: ${(props) =>
    props.disabled || props.isEmpty
      ? theme.palette.primitives.gray300
      : theme.palette.primitives.gray900};
  // padding: 7px 0;
  padding: 0;
  margin: 0;
  display: flex;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  box-sizing: border-box;
`;

const RightIconContainer = styled.div`
  width: 42px;
  height: 26px;
  padding: 0px 8px 0px 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-left: 1px solid ${theme.palette.primitives.gray200};
`;
